import { isNullOrEmpty } from "../../../../../../react-core/Utils/Arrays";
import { ProductType } from "../../../../../../Wrap/Constants/Enums/Domain/ProductType";
import { Money } from "../../../../../../Wrap/Core/DataTypes/Money";
import { TransferISTSelection } from "../../../../../../Wrap/Models/Models/InstrumentSelection/TransferISTSelection";

export class TransferHelper {
    static getTransferInvestmentTotal(investments: Array<TransferISTSelection>, residualCash: Money) {
        let total = 0;
        if (!isNullOrEmpty(investments)) {
            investments.forEach((investment) => {
                total += investment?.Investment?.UnitPrice?.Amount * investment.Units;
            });
        }
        if (residualCash?.Amount > 0) {
            total += residualCash.Amount;
        }
        return total;
    }

    static getTransferPeaInvestmentTotal(investments: Array<TransferISTSelection>) {
        let total = 0;
        if (!isNullOrEmpty(investments)) {
            investments.forEach((investment) => {
                if (![ProductType.Cash, ProductType.OffPlatform].includes(investment?.Investment?.Type)) {
                    total += investment?.Investment?.UnitPrice?.Amount * investment.Units;
                }
            });
        }
        return total;
    }
}
